module.exports = "<router-outlet></router-outlet>\n<ng4-loading-spinner [threshold]=\"0\" [timeout]=\"10000\"></ng4-loading-spinner>\n"